export const Message = {
    UploadUnsupportedFiles: 'System only supports 2 file types: XLS and XLSX. Please select again.',
    UploadInvalidFile: 'File is invalid'
} 